import { getCroppedImg } from "../../utils/profileImage";
import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cropper from "react-easy-crop";
import {
  Check,
  ChevronDown,
  ChevronUp,
  Plus,
  X,
  ZoomIn,
  ZoomOut,
} from "lucide-react";
import "./DogDetailsPage.css";

import progressIcon1 from "../../assets/progressIcon3.png";
import progressIcon2 from "../../assets/progressIcon7.png";
import nextIcon from "../../assets/nextButtonIcon.png";
import nextIcon2 from "../../assets/nextButtonIcon2.png";
import MobileTopBar from "../../components/MobileTopBar";
import MobileBottomBar from "../../components/MobileBottomBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import DesktopBottomBar from "../../components/DesktopBottomBar";

import { useGlobalAlert } from "../../context/AlertContext";
import { updateUser, updateFcmToken } from "../../services/userService";
import { updateDogProfile } from "../../services/dogService";
import { fetchUserData, updateProfileInStore } from "../../redux/userSlice";

// Hardcoded Breed List
const BREED_LIST = [
  "Affenpinscher",
  "Afghan Hound",
  "Airedale Terrier",
  "Akita",
  "Alaskan Malamute",
  "American Bulldog",
  "American Eskimo Dog",
  "American Foxhound",
  "American Pit Bull Terrier",
  "American Staffordshire Terrier",
  "Australian Cattle Dog",
  "Australian Shepherd",
  "Australian Terrier",
  "Aussiedoodle",
  "Basenji",
  "Basset Hound",
  "Beagle",
  "Bearded Collie",
  "Bedlington Terrier",
  "Belgian Malinois",
  "Belgian Sheepdog",
  "Belgian Tervuren",
  "Bernedoodle",
  "Mini Bernedoodle",
  "Bernese Mountain Dog",
  "Bichon Frise",
  "Black and Tan Coonhound",
  "Bloodhound",
  "Border Collie",
  "Border Terrier",
  "Borzoi",
  "Boston Terrier",
  "Bouvier des Flandres",
  "Boxer",
  "Boykin Spaniel",
  "Briard",
  "Brittany",
  "Brussels Griffon",
  "Bull Terrier",
  "Bulldog (English)",
  "Bullmastiff",
  "Cairn Terrier",
  "Canaan Dog",
  "Cane Corso",
  "Cardigan Welsh Corgi",
  "Cavalier King Charles Spaniel",
  "Cavapoo",
  "Chesapeake Bay Retriever",
  "Chiweenie",
  "Chihuahua",
  "Chinese Crested",
  "Chow Chow",
  "Clumber Spaniel",
  "Cockapoo",
  "Cocker Spaniel",
  "Collie",
  "Coton de Tulear",
  "Curly-Coated Retriever",
  "Dachshund",
  "Mini Dachshund",
  "Long-Haired Dachshund",
  "Wire-Haired Dachshund",
  "Dalmatian",
  "Dandie Dinmont Terrier",
  "Doberman Pinscher",
  "Dogo Argentino",
  "Dutch Shepherd",
  "English Setter",
  "English Springer Spaniel",
  "English Toy Spaniel",
  "Field Spaniel",
  "Finnish Spitz",
  "Flat-Coated Retriever",
  "French Bulldog",
  "German Pinscher",
  "German Shepherd",
  "German Shorthaired Pointer",
  "German Wirehaired Pointer",
  "Giant Schnauzer",
  "Glen of Imaal Terrier",
  "Golden Retriever",
  "Goldendoodle",
  "Mini Goldendoodle",
  "Gordon Setter",
  "Great Dane",
  "Great Pyrenees",
  "Greater Swiss Mountain Dog",
  "Greyhound",
  "Havanese",
  "Ibizan Hound",
  "Icelandic Sheepdog",
  "Irish Setter",
  "Irish Terrier",
  "Irish Water Spaniel",
  "Irish Wolfhound",
  "Italian Greyhound",
  "Jack Russell Terrier",
  "Japanese Chin",
  "Keeshond",
  "Kerry Blue Terrier",
  "Komondor",
  "Kuvasz",
  "Labrador Retriever",
  "Labradoodle",
  "Mini Labradoodle",
  "Lagotto Romagnolo",
  "Lakeland Terrier",
  "Leonberger",
  "Lhasa Apso",
  "Lowchen",
  "Maltese",
  "Maltipoo",
  "Manchester Terrier",
  "Mastiff",
  "Mini American Shepherd (Mini Aussie)",
  "Miniature Bull Terrier",
  "Miniature Pinscher",
  "Miniature Schnauzer",
  "Mini Poodle",
  "Morkie",
  "Neapolitan Mastiff",
  "Newfoundland",
  "Norfolk Terrier",
  "Norwegian Elkhound",
  "Norwich Terrier",
  "Old English Sheepdog",
  "Other",
  "Otterhound",
  "Papillon",
  "Parson Russell Terrier",
  "Pekingese",
  "Pembroke Welsh Corgi",
  "Petit Basset Griffon Vendéen",
  "Pharaoh Hound",
  "Plott Hound",
  "Pointer",
  "Pomsky",
  "Pomeranian",
  "Portuguese Water Dog",
  "Poodle (Standard)",
  "Poodle (Toy)",
  "Pug",
  "Puggle",
  "Puli",
  "Pyrenean Shepherd",
  "Rat Terrier",
  "Redbone Coonhound",
  "Rescue / Unknown",
  "Rhodesian Ridgeback",
  "Rottweiler",
  "Saint Bernard",
  "Saluki",
  "Samoyed",
  "Schipperke",
  "Schnoodle",
  "Scottish Deerhound",
  "Scottish Terrier",
  "Sealyham Terrier",
  "Shar-Pei",
  "Shetland Sheepdog",
  "Sheepadoodle",
  "Shiba Inu",
  "Shih Tzu",
  "Shorkie",
  "Siberian Husky",
  "Silky Terrier",
  "Skye Terrier",
  "Sloughi",
  "Smooth Fox Terrier",
  "Soft Coated Wheaten Terrier",
  "Spinone Italiano",
  "Staffordshire Bull Terrier",
  "Standard Schnauzer",
  "Sussex Spaniel",
  "Swedish Vallhund",
  "Tibetan Mastiff",
  "Tibetan Spaniel",
  "Tibetan Terrier",
  "Toy Fox Terrier",
  "Vizsla",
  "Weimaraner",
  "Welsh Springer Spaniel",
  "Welsh Terrier",
  "West Highland White Terrier",
  "Whippet",
  "Wire Fox Terrier",
  "Wirehaired Pointing Griffon",
  "Xoloitzcuintli",
  "Yorkipoo",
  "Yorkshire Terrier",
  "Mixed Breed",
];



const DogDetailsPage = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { triggerAlert } = useGlobalAlert();

  const [isLoading, setIsLoading] = useState(false);
  const fcmToken = useSelector((state) => state.user.fcmToken);
  const profile = useSelector((state) => state.user.profile);

  const dogName = formData.dogName || "Dog";

  const [mobileStep, setMobileStep] = useState(location.state?.step || 1);

  // LEFT PANEL STATE (DOG DETAILS)
  const [mainSearch, setMainSearch] = useState("");
  const [subSearches, setSubSearches] = useState({
    selectedBreed1: "",
    selectedBreed2: "",
    selectedBreed3: "",
  });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMainBreedDropdownOpen, setIsMainBreedDropdownOpen] = useState(false);
  const isMixedBreed =
    formData.dogBreed?.toLowerCase() === "mixed breed" ||
    formData.dogBreed?.toLowerCase() === "mix";

  // RIGHT PANEL STATE (PHOTOS)
  const mainImageRef = useRef(null);
  const subImageRefs = useRef([]);
  const [images, setImages] = useState({
    main: null,
    sub1: null,
    sub2: null,
    sub3: null,
  });

  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [cropImageSrc, setCropImageSrc] = useState(null);
  const [cropKey, setCropKey] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  useEffect(() => {
    const storedDataStr = sessionStorage.getItem("temp_old_user_data");
    let userData = profile;
    if (!userData && storedDataStr) {
      try {
        userData = JSON.parse(storedDataStr);
      } catch (e) {
        console.error("Error parsing temp_old_user_data", e);
      }
    }

    if (userData && (!formData.dogName || !formData.dogBreed)) {
      const firstDog = userData.dogs?.[0] || {};
      if (firstDog.id || firstDog.dog_name || firstDog.dog_breed) {
        const rawGender = (firstDog.dog_gender || "").toLowerCase();
        const formattedGender =
          rawGender === "female" || rawGender === "girl"
            ? "girl"
            : rawGender === "male" || rawGender === "boy"
              ? "boy"
              : "";

        const formattedDogPhotos = { ...(formData.dogPhotos || {}) };
        if (!formattedDogPhotos.main) {
          if (firstDog.dog_images?.[0])
            formattedDogPhotos.main = firstDog.dog_images[0];
        }
        if (firstDog.dog_images && Array.isArray(firstDog.dog_images)) {
          const remaining = firstDog.dog_images.filter(
            (img) => img !== formattedDogPhotos.main,
          );
          if (!formattedDogPhotos.sub1 && remaining[0])
            formattedDogPhotos.sub1 = remaining[0];
          if (!formattedDogPhotos.sub2 && remaining[1])
            formattedDogPhotos.sub2 = remaining[1];
          if (!formattedDogPhotos.sub3 && remaining[2])
            formattedDogPhotos.sub3 = remaining[2];
        }

        const dogMixedBreed = Array.isArray(firstDog.dog_mixedBreed)
          ? firstDog.dog_mixedBreed
          : [];

        setFormData((prev) => ({
          ...prev,
          dogId: firstDog.id || prev.dogId || "",
          dogName: firstDog.dog_name?.trim() || prev.dogName || "",
          dogGender: formattedGender || prev.dogGender || "",
          dogBreed: firstDog.dog_breed || prev.dogBreed || "",
          selectedBreed1: dogMixedBreed[0] || prev.selectedBreed1 || "",
          selectedBreed2: dogMixedBreed[1] || prev.selectedBreed2 || "",
          selectedBreed3: dogMixedBreed[2] || prev.selectedBreed3 || "",
          dogMixedBreed:
            dogMixedBreed.length > 0 ? dogMixedBreed : prev.dogMixedBreed || [],
          dogPhotos:
            Object.keys(formattedDogPhotos).length > 0
              ? formattedDogPhotos
              : prev.dogPhotos || {},
        }));
      }
    }
  }, [profile, formData.dogName, formData.dogBreed, setFormData]);

  // LEFT PANEL LOGIC
  useEffect(() => {
    if (!isMixedBreed) {
      setOpenDropdown(null);
      setFormData((prev) => ({
        ...prev,
        selectedBreed1: "",
        selectedBreed2: "",
        selectedBreed3: "",
        dogMixedBreed: [],
      }));
      setSubSearches({
        selectedBreed1: "",
        selectedBreed2: "",
        selectedBreed3: "",
      });
    }
  }, [isMixedBreed, setFormData]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (!e.target.closest(".dd-dropdown-wrapper")) {
        setIsMainBreedDropdownOpen(false);
        setOpenDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredMainBreeds = useMemo(() => {
    return BREED_LIST.filter((b) =>
      b.toLowerCase().includes(mainSearch.toLowerCase()),
    );
  }, [mainSearch]);

  const getFilteredSubBreeds = (field) => {
    const searchTerm = subSearches[field];
    return BREED_LIST.filter(
      (b) =>
        b !== "Mixed Breed" &&
        b !== "Mix" &&
        b.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMainBreedSelect = (breed) => {
    setFormData((prev) => ({ ...prev, dogBreed: breed }));
    setMainSearch("");
    setIsMainBreedDropdownOpen(false);
  };

  const handleBreedSelect = (field, breed) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: breed };
      const mixedBreedsArray = [
        updated.selectedBreed1,
        updated.selectedBreed2,
        updated.selectedBreed3,
      ].filter(Boolean);
      return {
        ...updated,
        dogMixedBreed: mixedBreedsArray,
      };
    });
    setSubSearches((prev) => ({ ...prev, [field]: "" }));
    setOpenDropdown(null);
  };

  const handleSelection = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // RIGHT PANEL LOGIC
  const handleImageSelect = (event, key) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setCropImageSrc(reader.result);
        setCropKey(key);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCropModalOpen(true);
      };
      event.target.value = "";
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPx) => {
    setCroppedAreaPixels(croppedAreaPx);
  }, []);

  const handleSaveCrop = async () => {
    try {
      const croppedFile = await getCroppedImg(
        cropImageSrc,
        croppedAreaPixels,
        cropKey,
      );
      if (croppedFile) {
        const imageUrl = URL.createObjectURL(croppedFile);
        setImages((prev) => ({ ...prev, [cropKey]: imageUrl }));
        setFormData((prev) => ({
          ...prev,
          dogPhotos: {
            ...(prev.dogPhotos || {}),
            [cropKey]: croppedFile,
          },
        }));
      }
    } catch (e) {
      console.error("Error generating crop", e);
    } finally {
      setCropModalOpen(false);
      setCropImageSrc(null);
    }
  };

  const handleCancelCrop = () => {
    setCropModalOpen(false);
    setCropImageSrc(null);
  };

  useEffect(() => {
    const photoData = formData.dogPhotos || {};
    const restoredImages = {};

    Object.entries(photoData).forEach(([key, file]) => {
      if (file instanceof File) {
        restoredImages[key] = URL.createObjectURL(file);
      } else if (typeof file === "string" && file !== "") {
        restoredImages[key] = file;
      }
    });

    if (Object.keys(restoredImages).length > 0) {
      setImages((prev) => ({ ...prev, ...restoredImages }));
    }

    return () => {
      Object.values(restoredImages).forEach((url) => {
        if (url && url.startsWith("blob:")) URL.revokeObjectURL(url);
      });
    };
  }, [formData.dogPhotos]);

  // VALIDATION
  const selectedSubBreedsCount = [
    formData.selectedBreed1,
    formData.selectedBreed2,
    formData.selectedBreed3,
  ].filter(Boolean).length;

  const isMixedBreedValid =
    (formData.dogBreed?.toLowerCase() !== "mixed breed" &&
      formData.dogBreed?.toLowerCase() !== "mix") ||
    selectedSubBreedsCount >= 2;

  const isStep1Valid = !!(
    formData.dogName?.trim() &&
    formData.dogBreed &&
    formData.dogGender &&
    isMixedBreedValid
  );

  const hasAtLeastOneImage = Object.values(images).some((img) => img !== null);
  const isStep2Valid = hasAtLeastOneImage;
  const isFinalNextEnabled = isStep1Valid && isStep2Valid;

  // SUBMISSION
  const userId = profile?.id || formData.id;
  const dogId =
    profile?.dogs && profile.dogs.length > 0
      ? profile.dogs[0].id
      : formData.dogId || null;

  const handleCombinedSubmit = async () => {
    if (isLoading) return;

    const isAddingAnotherDog =
      location.state?.from === "completion" || formData.isAddingAnotherDog;

    if (isAddingAnotherDog) {
      navigate("/dog-personality", {
        state: { step: 2, from: "add-another-dog" },
      });
      return;
    }

    if (!userId) {
      triggerAlert("User session not found. Please log in again.", "error");
      return;
    }

    setIsLoading(true);

    try {
      const mixedBreedsArray = [
        formData.selectedBreed1,
        formData.selectedBreed2,
        formData.selectedBreed3,
      ].filter(Boolean);

      const submitData = {
        ...formData,
        dog_mixedBreed: mixedBreedsArray,
        dogMixedBreed: mixedBreedsArray,
        user_dog_status: true,
        team_paws: true,
        team_social: false,
        isDogProfileHalfComplete: true,
        isDogProfileComplete: false,
      };

      await updateUser(userId, submitData, fcmToken);

      if (fcmToken) {
        try {
          await updateFcmToken(userId, fcmToken);
        } catch (fcmError) {
          console.error("Failed to update FCM token:", fcmError);
        }
      }

      if (dogId) {
        await updateDogProfile(dogId, userId, submitData, submitData);
      }

      const updatedProfileData = await dispatch(fetchUserData(userId)).unwrap();
      dispatch(updateProfileInStore(updatedProfileData));

      if (setFormData && updatedProfileData) {
        const firstDog = updatedProfileData.dogs?.[0] || {};
        // Only set DogDetailsPage necessary data after update
        setFormData((prev) => ({
          ...prev,
          dogId: firstDog.id || prev.dogId,
          dogName: firstDog.dog_name?.trim() || prev.dogName,
          dogBreed: firstDog.dog_breed || prev.dogBreed,
          dogMixedBreed: firstDog.dog_mixedBreed || prev.dogMixedBreed,
        }));
      }

      if (
        location.state?.fromHalfCompleted ||
        formData.dogPersonalityOrigin === "half-completed"
      ) {
        navigate("/dog-personality", { state: { step: 2 } });
      } else {
        navigate("/app-tour-page");
      }
    } catch (error) {
      console.error("Update failed:", error);
      triggerAlert(error.message || "Failed to update your profile.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleNext = () => {
    if (window.innerWidth >= 1024) {
      if (isFinalNextEnabled) handleCombinedSubmit();
    } else {
      if (isStep2Valid) handleCombinedSubmit();
    }
  };

  // NAVIGATION
  const handleBackNavigation = () => {
    const from = location.state?.from;
    const isAddingAnotherDog = formData.isAddingAnotherDog;

    if (from === "completion" || isAddingAnotherDog) {
      navigate("/completion-page");
    } else {
      navigate("/team-selection");
    }
  };

  const handleBackToDetails = () => {
    setMobileStep(1);
    window.scrollTo(0, 0);
  };

  const inactiveStyle = {
    opacity: 0.3,
    filter: "grayscale(1)",
    transition: "all 0.3s ease",
    cursor: "pointer",
  };

  const searchInputStyle = {
    border: "none",
    outline: "none",
    width: "100%",
    padding: "0",
    background: "transparent",
    fontSize: "inherit",
    fontFamily: "inherit",
    color: "inherit",
  };

  return (
    <div
      className={`dd-container ${mobileStep === 1 ? "show-step-1" : "show-step-2"}`}
    >
      <div className="dd-panel dd-left-panel">
        <MobileTopBar
          onBack={handleBackNavigation}
          backColor="#000"
          logoColor="#009fd9"
          blueLogo="true"
          isProtectedRoute={false}
        />

        <DesktopTopBar
          showBack={true}
          onBack={handleBackNavigation}
          backColor="#000"
          showProgress={true}
          progressIconSrc={progressIcon1}
          progressPercent={40}
          iconLeft={35}
          iconWidth="80px"
        />

        <div className="dd-content-wrapper">
          <div
            className="dd-header-section mobile-only"
            style={{ marginTop: "-12px" }}
          >
            <div
              className="dd-dog-icon-container"
              style={{ paddingLeft: "2rem" }}
            >
              <img
                src={progressIcon1}
                alt="Progress Step"
                className="dd-progress-icon"
              />
            </div>
            <div className="dd-progress-track">
              <div className="dd-progress-fill step-1-fill"></div>
            </div>
          </div>

          <div className="dd-form-group">
            <label className="dd-label">WHAT IS YOUR DOG'S NAME?</label>
            <input
              type="text"
              name="dogName"
              placeholder="Enter here"
              value={formData.dogName || ""}
              onChange={handleChange}
              className={`dd-text-input ${formData.dogName ? "has-value" : ""}`}
            />
          </div>

          <div className="dd-form-group dd-dropdown-wrapper">
            <label className="dd-label">
              WHAT BREED IS{" "}
              {formData.dogName ? formData.dogName.toUpperCase() : "[DOG NAME]"}
              ?
            </label>
            <p className="dd-sub-label">
              Start typing and choose from pre-populated drop-down breeds
            </p>

            <div
              className={`dd-dropdown-trigger ${isMainBreedDropdownOpen ? "open" : ""} ${formData.dogBreed ? "has-value" : ""}`}
              onClick={() => {
                setIsMainBreedDropdownOpen(true);
                setMainSearch("");
              }}
            >
              <input
                style={searchInputStyle}
                placeholder={formData.dogBreed || "Type or choose breed"}
                value={
                  isMainBreedDropdownOpen ? mainSearch : formData.dogBreed || ""
                }
                onChange={(e) => setMainSearch(e.target.value)}
              />
              {isMainBreedDropdownOpen ? (
                <ChevronUp size={20} />
              ) : (
                <ChevronDown size={20} />
              )}
            </div>

            {isMainBreedDropdownOpen && (
              <div className="dd-dropdown-menu">
                {filteredMainBreeds.map((breed, index) => (
                  <div
                    key={index}
                    className="dd-dropdown-option"
                    onClick={() => handleMainBreedSelect(breed)}
                  >
                    {breed}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="dd-form-group">
            <p className="dd-helper-text">
              If {formData.dogName || "[dog name]"} is a mix of breeds, simply
              choose “Mixed breed” above! After that choose their additional
              breeds here. Up to 3 breeds can be chosen.
            </p>

            {["selectedBreed1", "selectedBreed2", "selectedBreed3"].map(
              (field, idx) => (
                <div key={field} className="dd-dropdown-wrapper mb-2">
                  <div
                    className={`dd-dropdown-trigger ${openDropdown === field ? "open" : ""} ${formData[field] ? "has-value" : ""}`}
                    style={!isMixedBreed ? inactiveStyle : undefined}
                    onClick={() => {
                      if (isMixedBreed) {
                        setOpenDropdown(field);
                        setSubSearches((prev) => ({ ...prev, [field]: "" }));
                      }
                    }}
                  >
                    <input
                      style={searchInputStyle}
                      disabled={!isMixedBreed}
                      placeholder={formData[field] || `Select breed ${idx + 1}`}
                      value={
                        openDropdown === field
                          ? subSearches[field]
                          : formData[field] || ""
                      }
                      onChange={(e) =>
                        setSubSearches({
                          ...subSearches,
                          [field]: e.target.value,
                        })
                      }
                    />
                    {openDropdown === field ? (
                      <ChevronUp size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </div>

                  {isMixedBreed && openDropdown === field && (
                    <div className="dd-dropdown-menu">
                      {getFilteredSubBreeds(field).map((breed, i) => (
                        <div
                          key={i}
                          className="dd-dropdown-option"
                          onClick={() => handleBreedSelect(field, breed)}
                        >
                          {breed}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ),
            )}
          </div>

          <div className="dd-form-group">
            <label className="dd-label">
              SELECT{" "}
              {formData.dogName
                ? formData.dogName.toUpperCase() + "'S"
                : "[DOG NAME]'S"}{" "}
              GENDER
            </label>
            <div className="dd-gender-buttons">
              {["boy", "girl"].map((g) => (
                <button
                  key={g}
                  className={`dd-gender-btn ${formData.dogGender === g ? "active" : ""}`}
                  onClick={() => handleSelection("dogGender", g)}
                >
                  <div className="dd-btn-content">
                    {formData.dogGender === g && (
                      <Check size={20} strokeWidth={4} color="white" />
                    )}
                    <span
                      className="dd-btn-text"
                      style={{
                        color: formData.dogGender === g ? "white" : "black",
                      }}
                    >
                      GOOD {g.toUpperCase()}
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <MobileBottomBar
            onNext={() => isStep1Valid && setMobileStep(2)}
            isNextEnabled={isStep1Valid}
            nextIconSrc={nextIcon2}
            variant="blue"
          />
        </div>
      </div>

      <div className="dd-panel dd-right-panel">
        <MobileTopBar
          onBack={handleBackToDetails}
          backColor="#fff"
          logoColor="#fff"
          isProtectedRoute={false}
        />

        <div className="dd-content-wrapper dd-right-content">
          <div className="dd-header-section-right mobile-only">
            <div
              className="dd-dog-icon-container"
              style={{ paddingRight: "6rem" }}
            >
              <img
                src={progressIcon2}
                alt="Progress Step"
                className="dd-progress-icon"
              />
            </div>
            <div className="dd-progress-track">
              <div className="dd-progress-fill step-2-fill"></div>
            </div>
          </div>

          <div className="dd-text-group">
            <h1 className="dd-title dd-text-white">
              {dogName.toUpperCase()}'S PICS
            </h1>
            <p className="dd-subtitle dd-text-white-sub">
              A picture is worth a thousand words! A tongue-out headshot, a
              picture with you, even a puppy pic are all great choices!
            </p>
          </div>

          <div className="dd-photo-grid">
            <div
              className="dd-photo-box dd-main-photo"
              onClick={() => mainImageRef.current.click()}
            >
              <input
                type="file"
                hidden
                ref={mainImageRef}
                accept="image/*"
                onChange={(e) => handleImageSelect(e, "main")}
              />
              {images.main ? (
                <img
                  src={images.main}
                  alt="Main Upload"
                  className="dd-uploaded-img"
                />
              ) : (
                <Plus size={40} color="#000" />
              )}
            </div>

            <div className="dd-sub-photos-row">
              {["sub1", "sub2", "sub3"].map((key, index) => (
                <div
                  key={key}
                  className="dd-photo-box dd-sub-photo"
                  onClick={() => subImageRefs.current[index].click()}
                >
                  <input
                    type="file"
                    hidden
                    ref={(el) => (subImageRefs.current[index] = el)}
                    accept="image/*"
                    onChange={(e) => handleImageSelect(e, key)}
                  />
                  {images[key] ? (
                    <img
                      src={images[key]}
                      alt="Sub Upload"
                      className="dd-uploaded-img"
                    />
                  ) : (
                    <Plus size={32} color="#000" />
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="desktop-only" style={{ width: "100%" }}>
            <DesktopBottomBar
              onNext={handleNext}
              isNextEnabled={isFinalNextEnabled}
              nextIconSrc={nextIcon}
              showSkip={false}
              isLoading={isLoading}
              variant="green"
            />
          </div>

          <MobileBottomBar
            onNext={handleNext}
            isNextEnabled={isStep2Valid}
            nextIconSrc={nextIcon}
            showSkip={false}
            isLoading={isLoading}
            variant="green"
          />
        </div>
      </div>

      {cropModalOpen && cropImageSrc && (
        <div className="crop-modal-overlay">
          <div className="crop-modal-box">
            <button className="crop-close-btn" onClick={handleCancelCrop}>
              <X size={20} color="rgba(166, 28, 31, 1)" strokeWidth={3} />
            </button>

            <h2 className="crop-modal-title">Upload Picture</h2>

            <div className="crop-container">
              <Cropper
                image={cropImageSrc}
                crop={crop}
                zoom={zoom}
                aspect={1}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
                classes={{ containerClassName: "custom-cropper-container" }}
                cropAreaStyle={{ border: "2px dashed white" }}
              />
            </div>

            <div className="crop-slider-wrapper">
              <ZoomOut size={24} color="#000" />
              <input
                type="range"
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                aria-labelledby="Zoom"
                onChange={(e) => setZoom(e.target.value)}
                className="crop-slider"
              />
              <ZoomIn size={24} color="#000" />
            </div>

            <div className="crop-action-row">
              <button
                className="crop-btn-change"
                onClick={() => {
                  if (cropKey === "main") {
                    mainImageRef.current.click();
                  } else {
                    const index = parseInt(cropKey.replace("sub", "")) - 1;
                    subImageRefs.current[index].click();
                  }
                }}
              >
                CHANGE IMAGE
              </button>
              <button className="crop-btn-save" onClick={handleSaveCrop}>
                CROP & SAVE
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DogDetailsPage;
